(ns shared.core.components.recharts.gauge-chart
  (:require [shared.core.components.recharts.util :as recharts.util]
            [shared.core.style :as style]))

(defn gauge-chart
  [{:keys [label label-style stops value value-style average colors width height style pie-style]
    :or {label ""
         width 164
         height 182}}]
  (let [data (map-indexed (fn [i stop]
                            {:name (str "Stop " (inc i))
                             :value stop})
                          stops)
        invalid? (or (nil? value) (not (number? value)) (< value 0))
        start-angle 200
        end-angle -20
        height-ratio (+ 1 (Math/sin (recharts.util/deg->rad (- start-angle 180))))
        radius (min (/ width 2) (/ height height-ratio))
        cy (+ radius (/ (- height (* radius height-ratio)) 2))
        cx (/ width 2)
        cy-percent (* 100 (/ cy height))
        needle-angle (recharts.util/angle-for-value value (reduce + stops) start-angle end-angle)
        average-line-angle (recharts.util/angle-for-value average (reduce + stops) start-angle end-angle)
        average-line-start (recharts.util/position-for-angle cx cy (* radius 0.58) average-line-angle)
        average-line-end (recharts.util/position-for-angle cx cy (* radius 1.07) average-line-angle)]
    [:div {:style (merge {:position "relative"
                          :width width
                          :height height}
                         style)}
     [recharts.util/re-responsive-container {:width "100%" :height "100%"}
      [recharts.util/re-pie-chart
       [recharts.util/re-pie {:data data
                              :dataKey "value"
                              :cx (str cx "px")
                              :cy (str cy-percent "%")
                              :startAngle start-angle
                              :endAngle end-angle
                              :paddingAngle 1
                              :innerRadius (* radius 0.82)
                              :outerRadius radius
                              :stroke "transparent"
                              :style pie-style}
        (doall (map-indexed (fn [i _]
                              [recharts.util/re-cell {:key i
                                                      :fill (nth colors i)}])
                            data))]]]
     [:div {:style {:position "absolute"
                    :top (if label
                           (str (- cy-percent 18) "%")
                           (str (- cy-percent 11) "%"))
                    :left "50%"
                    :transform "translate(-50%, 0%)"
                    :display "flex"
                    :flex-direction "column"
                    :align-items "center"}}
      [:span {:style (merge {:font-family style/roboto-font-family
                             :font-size (str (* radius 0.44) "px")
                             :line-height "83.333%"
                             :font-weight style/font-semi-bold-weight
                             :color (if invalid?
                                      (style/alc-color "Text/secondary")
                                      (style/alc-color "Text/primary"))}
                            value-style)}
       (if invalid? "N/A" (str value))]
      (when label
        [:span {:style (merge {:margin-top 5
                               :font-family style/roboto-font-family
                               :font-size (str (* radius 0.122) "px")
                               :color (style/alc-color "Text/primary")}
                              label-style)}
         label])]

     [:svg {:width width
            :height height
            :style {:position :absolute
                    :top 0
                    :left 0
                    :overflow :visible}}
      [:defs
       [:filter {:id "shadow" :x "-50%" :y "-20%" :width "200%" :height "200%"}
        [:feDropShadow {:dx 0 :dy 2 :std-deviation "2" :flood-color "#000" :flood-opacity "0.27"}]]]
      (when (not invalid?)
        [:polygon {:points (recharts.util/needle-polygon-points cx cy radius needle-angle (* radius 0.073))
                   :fill "#fff"
                   :filter "url(#shadow)"}])
      (when average
        [:line {:x1 (:x average-line-start)
                :y1 (:y average-line-start)
                :x2 (:x average-line-end)
                :y2 (:y average-line-end)
                :stroke (style/alc-color "Text/primary")
                :stroke-width 1
                :stroke-dasharray "2.5,2.5,2.5,2.5"}])]]))